<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 20 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <path
                id="path-1"
                d="M12.6790541,0 L0.84527027,0 C0.378434544,0 0,0.377753906 0,0.84375 L0,1.40625 C0,1.87224609 0.378434544,2.25 0.84527027,2.25 C0.84527027,5.44798828 2.64203311,8.14689844 5.10127652,9 C2.64203311,9.85310156 0.84527027,12.5520117 0.84527027,15.75 C0.378434544,15.75 0,16.1277539 0,16.59375 L0,17.15625 C0,17.6222461 0.378434544,18 0.84527027,18 L12.6790541,18 C13.1458898,18 13.5243243,17.6222461 13.5243243,17.15625 L13.5243243,16.59375 C13.5243243,16.1277539 13.1458898,15.75 12.6790541,15.75 C12.6790541,12.5520117 10.8822912,9.85310156 8.4230478,9 C10.8822912,8.14689844 12.6790541,5.44798828 12.6790541,2.25 C13.1458898,2.25 13.5243243,1.87224609 13.5243243,1.40625 L13.5243243,0.84375 C13.5243243,0.377753906 13.1458898,0 12.6790541,0 Z M10.0348375,13.5 L3.48955734,13.5 C4.09036843,11.854793 5.32435741,10.6875 6.7621622,10.6875 C8.19986133,10.6875 9.4339912,11.8545469 10.0348375,13.5 Z M10.0355062,4.5 L3.48948692,4.5 C3.23978,3.81614063 3.09932426,3.04973437 3.09932426,2.25 L10.4249997,2.25 C10.4249997,3.05173828 10.2845792,3.81751172 10.0355062,4.5 L10.0355062,4.5 Z"
            />
        </defs>
        <g id="Final" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Landing-page-(CW)---4" transform="translate(-273.000000, -675.000000)">
                <g id="Group-4" transform="translate(250.000000, 653.000000)">
                    <g id="Icons-/-Pending" transform="translate(21.000000, 22.000000)">
                        <g id="hourglass-half" transform="translate(2.237838, 0.000000)">
                            <g id="Rectangle">
                                <mask id="mask-2" fill="white"><use xlink:href="#path-1" /></mask>
                                <use
                                    id="Mask"
                                    :fill="color"
                                    fill-rule="nonzero"
                                    xlink:href="#path-1"
                                />
                                <rect
                                    mask="url(#mask-2)"
                                    x="-2.23783784"
                                    y="0"
                                    :width="size"
                                    :height="size"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'HourglassSVG',
    props: {
        size: {
            type: Number,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
    },
};
</script>

<style></style>
